<template>
<div class="onecon">
    <div class="carousel">
        <Carousel autoplay :autoplay-speed="setting.autoplaySpeed" :dots="setting.dots" :trigger="setting.trigger" :arrow="setting.arrow">
            <Carousel-item v-for="(item,index) in imgs" :key="index">
                <div class="demo-carousel">
                    <img :src="item">
                </div>
            </Carousel-item>
        </Carousel>
        <div class="sep10"></div>

        <bar info="公司"></bar>
        <div class="intro">
            <p>
                <br />
            </p>
            <p style="color:#333333;font-family:&quot;font-size:14px;background-color:#FFFFFF;text-indent:2em;">
                <span style="line-height:2;font-size:14px;">&nbsp;  郑州方程世纪数码信息技术有限公司主营银行业务，致力于金融行业、证券行业的软件产品的开发、系统集成以及系统周边硬件产品的研制开发。主要产品包括：《商业银行与人民银行间现金往来业务无线加密预约数据采集及IC卡身份验证安全管理系统（WPI-1)》、《现金中心交接验证系统》。。。</span>
            </p>
            <p style="color:#333333;font-family:&quot;font-size:14px;background-color:#FFFFFF;text-indent:2em;">
                <br />
                <span style="line-height:2;font-size:14px;">公司宗旨：</span>
            </p>
            <p style="color:#333333;font-family:&quot;font-size:14px;background-color:#FFFFFF;text-indent:2em;">
                <span style="line-height:2;font-family:隶书, SimLi;font-size:24px;">诚信与人 &nbsp;德信于人</span>
            </p>
            <p>
                <br />
            </p>
        </div>
    </div>
    <bar info="产品"></bar>
    <div class="product_con">
        <div class="list">
            <template class="list" v-for="(item,index) in infos">
                <product :info="item" :key="index"></product>
            </template>
        </div>

    </div>
</div>
</template>

<script>
import product from '@/components/product.vue'
import bar from "@/components/bar.vue"
export default {
    data() {
        return {
            setting: {
                autoplay: false,
                autoplaySpeed: 5000,
                dots: 'inside',
                trigger: 'click',
                arrow: 'hover'
            },
            infos: [{
                    img: "1491481186.jpg",
                    title: '银行无线预约管理系统'
                },
                {
                    img: "1491529608.jpg",
                    title: '银行库款交接管理系统'
                },
                {
                    img: "1491529939.jpg",
                    title: "银行上面收款管理系统"
                },
                {
                    img: '1491530032.jpg',
                    title: '现金中心管理系统'
                }
            ],
            imgs: [
                "1490862442.jpg",
                "1492669655.jpg"
            ]
        }
    },
    components: {
        product,
        bar
    }
}
</script>

<style lang="scss" scoped>
.onecon {
    // width: 1120px;
    // margin: 0 auto;

}

img {
    height: 400px;
    width: 1120px;
}

.sep10 {
    height: 10px;
}

.product_con {
    border: 1px solid #f4f4f4;
    min-height: 220px;
    background: #f7f8fa;
    // padding: 8px 16px;

    .list {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: flex-start;
        width: 1120px;
        margin: 0 auto;
    }

}
.intro {
  width: 1120px;
  margin: 0 auto;
  text-align: left;
}
</style>
